<template>
  <section :class="displayLayout">
    <van-popup
      class="popup-wrapper pay-popup"
      :class="isNewClass"
      round
      v-model="show"
      position="bottom"
    >
      <div class="password-header">
        <span>{{ $t('account.input_pw') }}</span>
      </div>
      <!-- 密码输入框 -->
      <van-password-input
        :value="password"
        :gutter="10"
        :length="6"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
      />
      <p class="pw-setting-entry">
        <span @click="retreivePassword">{{ $t('account.retrieve_pw') }}</span>
      </p>
      <div class="ignore-placeholder"></div>

      <!-- 数字键盘 -->
      <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        :hide-on-click-outside="false"
      />
    </van-popup>
    <NoticePopup
      :frozenScene="frozenScene"
      :status="status"
      :query="query"
      v-model="showPopup"
      @emptyInputPassword="emptyInputPassword"
      @retreivePassword="retreivePassword"
    />
  </section>
</template>
<script>
  import Vue from 'vue'
  import { PasswordInput, NumberKeyboard } from 'vant'
  import NoticePopup from './Notice'
  import { sixDigitsReg } from '@/utils/regExp'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { encodePasswordBySha256 } from '@/api/common'
  import { walletRechargePopup } from '@/pages/Detail/firebase.js'
  import '@vant/touch-emulator'

  Vue.use(PasswordInput)
  Vue.use(NumberKeyboard)

  // 输入密码
  export default {
    name: 'use-password',
    props: {
      value: [Boolean],
    },
    components: {
      NoticePopup,
    },
    data() {
      return {
        showPopup: false,
        status: '',
        show: this.value,
        showKeyboard: true,
        password: '',
        isFrozen: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'paymentAccountInfo']),
      ...mapGetters(['displayLayout', 'isNewClass']),
      query() {
        return {
          ...this.$route.query,
          from: this.gameName,
        }
      },
      frozenScene() {
        const { frozenScene } = this.paymentAccountInfo || {}
        return frozenScene || 0
      },
    },
    watch: {
      value(val) {
        this.show = val
        if (val) {
          walletRechargePopup(this.gameName, 'consume')
        }
      },
      show(val) {
        if (!val) {
          this.password = '' // 每次隐藏之后都清空键盘
          this.setCreateOrderState('cancel')
          this.$emit('input', val)
        }
      },
      showPopup(val) {
        if (!val) {
          // 每次隐藏错误提示弹窗时，都要告知父组件以便重置标记状态
          this.$emit('resetPayPopupStatus')
          if (this.isFrozen) {
            // 当账户冻结后，直接关闭密码输入框
            this.show = false
          }
        }
      },
      password(val, oldVal) {
        // 超过6位时,去掉多余的数字
        if (val.length > 6) {
          this.password = val.slice(0, 6)
        }
        // 校验是否是6位数字
        if (sixDigitsReg.test(val) && oldVal.length <= 6) {
          this.toPay() // 输入6位密码后直接创建订单，密码校验结果在 create/order 接口中返回
        }
      },
    },
    methods: {
      ...mapMutations(['setCreateOrderState']),
      displayNoticePopup(type) {
        this.status = type
        this.showPopup = true
        this.isFrozen = type === 'errorLimit' || type === 'frozen'
        if (this.isFrozen) {
          // 钱包账户冻结后重新查询账户信息
          this.$emit('queryAccountInfo')
        }
      },
      emptyInputPassword() {
        this.password = ''
      },
      retreivePassword() {
        this.$emit('retreivePassword')
        this.show = false
      },
      goto(page) {
        this.$router_push({
          path: `/${page}`,
          query: {
            ...this.$route.query,
            from: this.gameName,
          },
        })
      },
      toPay() {
        this.$emit('createOrder', {
          encodedPw: encodePasswordBySha256(this.password),
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .popup-wrapper.pay-popup {
    background: #f9f9f9;
    padding: 0 80px;
    font-family: 'Manrope';
    box-sizing: border-box;
    .password-header {
      margin: 60px auto;
      text-align: center;
      font-weight: 800;
      font-size: 54px;
      line-height: 74px;
    }
    .van-password-input {
      margin: 20px 0;
    }
    .pw-setting-entry {
      margin: 80px auto 60px;
      text-align: center;
      font-weight: 700;
      font-size: 36px;
      line-height: 49px;
      color: #f96000;
      cursor: pointer;
    }
    // 键盘的容器高度为244px
    .ignore-placeholder {
      height: 260px;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  .gt-layout .popup-wrapper.pay-popup {
    .password-header {
      margin: 40px auto;
    }
    .pw-setting-entry {
      margin: 50px auto 10px;
    }
    .ignore-placeholder {
      height: 240px;
    }
    .van-number-keyboard {
      padding-bottom: 6px;
    }
  }

  .popup-wrapper.pay-popup.is-new {
    background: $gray-popup;
    .password-header {
      color: $white;
    }
    .van-password-input__item {
      background: $white-1;
      border-radius: 12px;
      .van-password-input__cursor {
        background-color: $orange;
      }
    }
    .van-password-input__security i {
      background-color: $orange;
    }

    .van-number-keyboard {
      background-color: #363b3f;
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './Pay_pc.scss';
  }
</style>
